import React from 'react';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import StarIcon from '@mui/icons-material/Star';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import SectionTile from './SectionTile';
import ArchiveOldMenu from './ArchiveOldMenu';

// One publisher (client) accordion row plus its bucket tiles.
//
// Spec 2.2 removes pending counts, total/completed/published counts and the
// My-order up/down arrows. Spec 2.3 leaves only the active-suggestion total.
export default function PublisherRow({
  client,
  expanded,
  onToggle,
  isFavourite,
  onToggleFavourite,
  onOpenBucket,
  favouriteBuckets = [],
  onToggleFavouriteBucket,
  onCopyAllLinks,
  onEmailAllLinks,
  onArchiveStale,
  busyAction,
}) {
  const { clientId, clientName, buckets, metrics } = client;
  const total = metrics.activeSuggestions;

  return (
    <div className="pbnew-pub">
      <div className="pbnew-pub-row" onClick={() => onToggle(clientId)}>
        <span className={`pbnew-chev ${expanded ? 'open' : ''}`}>
          <KeyboardArrowRightOutlinedIcon style={{ fontSize: 20 }} />
        </span>
        <span className="pbnew-pub-name">{clientName}</span>
        <button
          type="button"
          className={`pbnew-pub-star ${isFavourite ? 'on' : ''}`}
          onClick={(e) => { e.stopPropagation(); onToggleFavourite(clientId); }}
          title={isFavourite ? 'Remove from favourites' : 'Add to favourites'}
        >
          {isFavourite ? <StarIcon style={{ fontSize: 16 }} /> : <StarBorderOutlinedIcon style={{ fontSize: 16 }} />}
        </button>
        <span className="pbnew-lang">{metrics.language}</span>
        <div className="pbnew-pub-meta">
          <span>
            {total} active suggestion{total === 1 ? '' : 's'} · {metrics.sections} bucket
            {metrics.sections === 1 ? '' : 's'}
          </span>
        </div>
      </div>

      {expanded && (
        <>
          {/* Spec 3.1 — publisher-wide actions, shown on the expanded row. */}
          <div className="pbnew-pub-actions" onClick={(e) => e.stopPropagation()}>
            <button
              className="pbnew-btn"
              onClick={() => onCopyAllLinks(client)}
              disabled={busyAction === 'copy'}
            >
              <ContentCopyOutlinedIcon style={{ fontSize: 15 }} />
              {busyAction === 'copy' ? 'Creating links…' : 'Copy all bucket links'}
            </button>
            <button
              className="pbnew-btn"
              onClick={() => onEmailAllLinks(client)}
              disabled={busyAction === 'email'}
            >
              <EmailOutlinedIcon style={{ fontSize: 15 }} />
              {busyAction === 'email' ? 'Sending…' : 'Email all bucket links'}
            </button>
            {/* Spec 4.3 — publisher-wide stale archive. The cutoff is computed
                separately for each bucket, and buckets without a completed
                automated fill are identified in the confirmation. */}
            <ArchiveOldMenu onPick={(rule) => onArchiveStale(client, rule)} />
          </div>

          <div className="pbnew-sections">
            {buckets.map((b) => (
              <SectionTile
              key={b._id}
              bucket={b}
              onOpen={onOpenBucket}
              isFavourite={favouriteBuckets.includes(b._id)}
              onToggleFavourite={onToggleFavouriteBucket}
            />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
